import { getDistributionText } from 'automation-ui-action-features/actions/rotate-object/utils/action-message';
import { useMemo } from 'react';
import { getUsersAndTeams } from 'routing-ui/routing-rules/operators/routingRulesGetters';
import count from 'transmute/count';
const getUnifiedRoutingExplainerMessageType = (userIds, teamIds) => {
  const teamCount = count(teamIds);
  const userCount = count(userIds);
  if (teamCount > 0 && userCount > 0) {
    return {
      type: 'users-and-teams'
    };
  }
  if (userCount > 0) {
    return {
      count: userCount,
      type: 'users-only'
    };
  }
  if (teamCount > 0) {
    return {
      count: teamCount,
      type: 'teams-only'
    };
  }
  return {
    type: ''
  };
};
export const useUnifiedRoutingExplainerMessage = routingRuleDefinition => useMemo(() => {
  const {
    teamIds,
    userIds
  } = getUsersAndTeams(routingRuleDefinition);
  const type = getUnifiedRoutingExplainerMessageType(userIds, teamIds);
  return Object.assign({
    distribution: getDistributionText(routingRuleDefinition),
    teamIds,
    userIds
  }, type);
}, [routingRuleDefinition]);